module.exports = __webpack_public_path__ + "img/vertical.675e88dd.jpg";